import React, { PureComponent } from 'react';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { FundraiserCardLarge } from '@client/containers/fundraiserCardLarge/FundraiserCardLarge';
import { selectMyFundraisers, loadMyFundraisers } from '@client/redux/user';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styles from './myFundraisersRoute.scss';

class MyFundraisersRoute extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.dispatch(loadMyFundraisers());
  }

  render() {
    const { fundraisers } = this.props;

    const fundraiserList = getIn(fundraisers, 'results');

    return (
      <div className={styles.myFundraisersRoute}>
        <h3
          className={`${styleHelper.titleMdPrimary} ${styleHelper._title} ${styles.title}`}
        >
          Mina insamlingar
        </h3>
        <div className={styles.foundraisers}>
          {fundraiserList &&
            fundraiserList.map((fundraiser) => {
              return (
                <FundraiserCardLarge
                  key={getIn(fundraiser, 'id')}
                  fundraiser={fundraiser}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

MyFundraisersRoute.propTypes = {
  fundraisers: ImmutablePropTypes.map,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    fundraisers: selectMyFundraisers(state),
  };
}

export default withRouter(connect(mapStateToProps)(MyFundraisersRoute));
